'use client';

import { useState, useContext, type FC } from 'react';
import { Alert, Button, ButtonGroup, Dialog, Flex } from '@/_components';
import { saveQuestionnaires } from '@/_api/admin-questionnaires';
import { ToastContext } from '@/_contexts/ToastProvider';
import { UserContext } from '@/_contexts/UserProvider';
import { EditRemindersDialogProps } from './EditRemindersDialog.types';

export const EditRemindersDialog: FC<EditRemindersDialogProps> = ({
  isOpen,
  onClose,
  selectedQuestionnaires,
}) => {
  const { addToast } = useContext(ToastContext);
  const { token } = useContext(UserContext);

  const [isLoading, setIsLoading] = useState(false);

  const onEdit = async (remindersDisabled: boolean) => {
    try {
      setIsLoading(true);

      await saveQuestionnaires({
        reminders_disabled: remindersDisabled,
        questionnaire_ids:
          selectedQuestionnaires.filter((q) => !q.locked).map((q) => q.id) ||
          [],
        token,
      });

      addToast('success', 'Notifications successfully updated');
    } catch (error) {
      addToast('error', null, { error });
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return (
    <Dialog isNarrow isOpen={isOpen} onClose={onClose} title="Edit Reminders">
      <Dialog.Content>
        <Flex isColumn={true} gap={6}>
          <Alert type="info" icon="info">
            Would you like to enable or disable reminders for the selected
            questionnaires?
            <br />
            <i>Note: they are enabled by default.</i>
          </Alert>

          <ButtonGroup align="right" isSameLine>
            <Button
              intent="primary"
              isDisabled={isLoading}
              onClick={() => onEdit(false)}
              value="Enable"
            />

            <Button
              intent="danger"
              isDisabled={isLoading}
              onClick={() => onEdit(true)}
              value="Disable"
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
